import { TextField } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { validateStructureSetLabel } from '~/utils/validation';

export default function StructureSetLabelField({
    structureSetLabel,
    onChange,
}: {
    structureSetLabel: string;
    onChange: (value: string) => void;
}) {
    const [newStructureSetLabel, setNewStructureSetLabel] =
        useState(structureSetLabel);
    const [validationError, setValidationError] = useState<string | null>(null);

    useEffect(() => {
        if (validationError) {
            enqueueSnackbar(validationError, { variant: 'warning' });
            setValidationError(null);
        }
    }, [validationError]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewStructureSetLabel(e.target.value);
    };

    const handleEditingEnd = () => {
        const trimmedLabel = newStructureSetLabel.trim();
        const [isValid, errorMessage] = validateStructureSetLabel(trimmedLabel);
        if (!isValid) {
            setValidationError(errorMessage);
            setNewStructureSetLabel(structureSetLabel);
            return;
        } else {
            onChange(trimmedLabel);
        }
    };

    return (
        <TextField
            type="text"
            value={newStructureSetLabel}
            onChange={handleInputChange}
            onBlur={handleEditingEnd}
            autoFocus
            label={<FormattedMessage id="label" />}
            variant="outlined"
            size="small"
            fullWidth
            data-testid="structure-set-label-field"
            onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === 'Enter') {
                    handleEditingEnd();
                }
            }}
        />
    );
}
